export default {
  visibleName: {
    id: 'product_page_telco_comparison_visible_name',
    defaultMessage: 'Visible by Verizon plan',
  },
  visibleNetwork: {
    id: 'product_page_telco_comparison_visible_network',
    defaultMessage: 'Powered by Verizon',
  },
  visibleData: {
    id: 'product_page_telco_comparison_visible_data',
    defaultMessage: 'Unlimited data',
  },
  visibleHotspot: {
    id: 'product_page_telco_comparison_visible_hotspot',
    defaultMessage: 'Unlimited hotspot',
  },
  visiblePrice: {
    id: 'product_page_telco_comparison_visible_price',
    defaultMessage: '$25/mo',
  },
  visiblePriceOld: {
    id: 'front_office_product_core_telco_visible_price_old',
    defaultMessage: '$25.00',
  },
  visiblePriceNew: {
    id: 'front_office_product_core_telco_visible_price_new',
    defaultMessage: '$20.00/month',
  },
  visiblePickerSubLine: {
    id: 'front_office_product_core_telco_visible_picker_sub_line',
    defaultMessage:
      "Unlimited 5G data on Verizon's award-winning network. Deal lasts 24 months, cancel anytime.",
  },
  visibleBullet1: {
    id: 'front_office_product_core_telco_visible_bullet_1',
    defaultMessage:
      "Unlimited 5G data, talk and text on Verizon's award-winning network",
  },
  visibleBullet2: {
    id: 'front_office_product_core_telco_visible_bullet_2',
    defaultMessage: 'Unlimited mobile hotspot at 5Mbps',
  },
  visibleBullet3: {
    id: 'front_office_product_core_telco_visible_bullet_3',
    defaultMessage: 'Unlimited talk and text in Mexico and Canada',
  },
  visibleOfferLine: {
    id: 'front_office_product_core_telco_visible_offer_line',
    defaultMessage:
      'Exclusively with Back Market, get your first 24 months for $20.00/month, then $25.00/month.',
  },
  nobleName: {
    id: 'product_page_telco_comparison_noble_name',
    defaultMessage: 'Noble Mobile No-Bull plan',
  },
  nobleNetwork: {
    id: 'product_page_telco_comparison_noble_network',
    defaultMessage: 'Nationwide 5G coverage',
  },
  nobleData: {
    id: 'product_page_telco_comparison_noble_data',
    defaultMessage: 'Unlimited data',
  },
  nobleHotspot: {
    id: 'product_page_telco_comparison_noble_hotspot',
    defaultMessage: '10GB hotspot',
  },
  noblePrice: {
    id: 'product_page_telco_comparison_noble_price',
    defaultMessage: '$10/mo',
  },
  noblePriceOld: {
    id: 'front_office_product_core_telco_noble_price_old',
    defaultMessage: '$50.00',
  },
  noblePriceNew: {
    id: 'front_office_product_core_telco_noble_price_new',
    defaultMessage: '$10.00/month',
  },
  noblePickerSubLine: {
    id: 'front_office_product_core_telco_noble_picker_sub_line',
    defaultMessage:
      'Unlimited data, talk, & text on the T-Mobile 5G Network. Deal lasts for 3 months.',
  },
  nobleBullet1: {
    id: 'front_office_product_core_telco_noble_bullet_1',
    defaultMessage:
      'Unlimited 5G data, talk and text on the T-Mobile 5G Network',
  },
  nobleBullet2: {
    id: 'front_office_product_core_telco_noble_bullet_2',
    defaultMessage:
      'Unlimited international calling to 80+ countries and unlimited texting to almost anywhere',
  },
  nobleBullet3: {
    id: 'front_office_product_core_telco_noble_bullet_3',
    defaultMessage: 'Cash back when you use less data',
  },
  nobleOfferLine: {
    id: 'front_office_product_core_telco_noble_offer_line',
    defaultMessage:
      'Exclusively with Back Market, get your first 3 months for $10.00/mo, then $50.00/month.',
  },
  googleFiName: {
    id: 'product_page_telco_comparison_google_fi_name',
    defaultMessage: 'Google Fi',
  },
  bestPhonePlansName: {
    id: 'product_page_telco_comparison_best_phone_plans_name',
    defaultMessage: 'Best Phone Plans',
  },
  rakutenName: {
    id: 'product_page_telco_comparison_rakuten_name',
    defaultMessage: 'Rakuten',
  },
  usMobileName: {
    id: 'product_page_telco_comparison_us_mobile_name',
    defaultMessage: 'US Mobile',
  },
  duolingoName: {
    id: 'product_page_telco_comparison_duolingo_name',
    defaultMessage: 'Duolingo',
  },
}
